window.addEventListener("load", function() { 
var addtocartloader = $('<span class="promo-loader"><span style="position: absolute;width:100%;text-align:center;top:62%;">Adding product to bag...</span></span>');
var promoloader = $('<span class="promo-loader1"><span style="position: absolute;width:100%;text-align:center;top:62%;">Checking for available promotions...</span></span>');
var pageurl = window.location.pathname.indexOf("checkout") != -1 ? window.location.origin:window.theme.localeRootUrl;
$('body').on('click','.custom-ajax',function(e){
  ajaxaddProduct($(this),$(this).attr('variant-id'),1,'product');

});
var addToCartPopup = document.getElementById('add-to-cart');
/* To check how many items are there in the cart and add the samples accordingly */

var ajaxcount = 0;
var ajaxfreeProduct = [4364960825484,31233467646092];
var ajaxgiftPresent = 0;
var ajaxgwpQualifier = function ajaxgwpQualifier(data) {
  jQuery.each(data.items, function(key, value) {
    if(value.product_id == ajaxfreeProduct[0]) { 
      ajaxgiftPresent = value.quantity;
    }
    if(value.product_id != ajaxfreeProduct[0]) { 
      ajaxcount++;
    }
  });

  if(!ajaxgiftPresent && ajaxcount > 0) {
    $.ajax({
      url: 'https://apps.napoleonperdis.com/api/get-variant-details',
      data : { product_id:ajaxfreeProduct[0]},
      type: 'GET',
      dataType: 'json',
      success: function(data) {
        if(data.qty > 0)
          ajaxaddProduct(null,ajaxfreeProduct[1],1,'gwp');
      }
    });

  }

}


function ajaxaddProduct(buttonobj,variantid,qty,type) {
  if(type=='promo')
    ajaxshowloader1();
  else if(type=='product') {
      buttonobj.children('span').eq(0).addClass('adding');
      buttonobj.children('span').eq(0).html('Adding...'); 
      ajaxshowloader();
  }

  var dataInfo;
  if(type== 'gwp') {

    dataInfo = {
      quantity: qty,
      id: variantid,
      properties: {
        'Note': 'A Free Gift For You'
      }
    };

  } 
  else {
    dataInfo = {
      quantity: qty,
      id: variantid
    };
  }
  $.ajax({
    url: pageurl+'/cart/add.js',
    type: 'POST',
    dataType: 'json',
    data: dataInfo,
    success: function(data) {
      if(data.original_price != 0 ) {
        jQuery('#add-to-cart .p-img').attr('src',data.featured_image.url);
        jQuery('#add-to-cart .p-name').html(data.title);
        jQuery('#add-to-cart #added-qty').html(1);
        jQuery('#add-to-cart #added-price').html(data.original_price/100);
      }
      $.ajax({
        url: pageurl+'/cart.js',
        type: 'GET',
        dataType: 'json',
        success: function(data) {
          jQuery('.Header__CartCount').html(data.item_count);
          jQuery('.Header__CartDot').addClass('is-visible');
          //addtocartloader.remove();
          /* To disable the popup for lipstick promo */
          if(type != 'gwp') {
            addToCartPopup.style.display='block';
            ajaxshowOverlay();
          }
          ajaxgwpQualifier(data);
        }
      });
    },
    error: function (jqXHR, exception) {
      location.href = window.location.href;
    }
  });

}
function ajaxshowloader() {
  //addtocartloader.insertAfter('body');
  ajaxshowOverlay();
}
function ajaxshowloader1() {
  promoloader.insertAfter('body');
  ajaxshowOverlay();
}
function ajaxshowOverlay() {
  $('.PageOverlay').css('opacity',0);
  $('.PageOverlay').css('visibility','visible');
}
function ajaxhideOverlay() {
  $('.PageOverlay').css('opacity',0);
  $('.PageOverlay').css('visibility','hidden');
}
var addtocartmodal = document.getElementById("add-to-cart");
var closeButton = document.getElementsByClassName("add-to-cart-close")[0];
if(closeButton) {
  closeButton.onclick = function(event) {
    addtocartmodal.style.display = "none";
    ajaxhideOverlay();
    if(Shopify.cart != null) {
      location.href = window.location.href;
    }
    jQuery('.adding').parent().removeAttr('disabled');
    jQuery('.adding').html('Add to bag');
    jQuery('.adding').removeClass('adding');
    jQuery('#add-to-cart .p-img').show();
    jQuery('#add-to-cart .p-name').show();
    jQuery('#add-to-cart .Alert--error').html('');
  }
}
});